export enum GroupStatus {
  AllChecked,
  NoneChecked,
  PartiallyChecked,
}
